<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>平台数据</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>数据中心</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>

    <el-row :gutter="20">
      <el-col :span="6">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon">
            <i class="el-icon-share"></i>
          </div>
          <div class="box-title">
            <div class="online">在线设备</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="sum_manage" :duration="3000"></count-to>
            </span>
            <span class="nums">+ 2.4%</span>
          </div>
        </div>
      </el-col>

      <el-col :span="6">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon">
            <i class="el-icon-share"></i>
          </div>
          <div class="box-title">
            <div class="online">在线设备</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="sum_manage" :duration="3000"></count-to>
            </span>
            <span class="nums">+ 2.4%</span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon">
            <i class="el-icon-share"></i>
          </div>
          <div class="box-title">
            <div class="online">在线设备</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="sum_manage" :duration="3000"></count-to>
            </span>
            <span class="nums">+ 2.4%</span>
          </div>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="dis_jcsb box-cell mar_B_20">
          <div class="box-icon">
            <i class="el-icon-share"></i>
          </div>
          <div class="box-title">
            <div class="online">在线设备</div>
            <div class="yestaday">昨日同比</div>
          </div>
          <div class="box-nums">
            <span class="total">
              <count-to :startVal="0" :endVal="sum_manage" :duration="3000"></count-to>
            </span>
            <span class="nums">+ 2.4%</span>
          </div>
        </div>
      </el-col>
    </el-row>

    <div v-loading="loading.loading">

      <el-row class="mt10">
        <el-col :span="18" class="pr5 mb10">
          <el-card>
            <div class="flex space" style="position: relative;z-index: 1">
              <b>最近一周活跃设备</b>
            </div>
            <ve-line :data="courseData"></ve-line>
          </el-card>
        </el-col>
        <el-col :span="6" class="pr5 mb10">
          <el-card>
            <div slot="header">
              <span>用户统计</span>
            </div>
            <div>
              <ve-ring height="250px" width="350px" :data="chartData" :extend="chartExtend" :settings="chartSettings">
              </ve-ring>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>

  </div>
</template>
<style>
.box-cell {
  overflow: hidden;
  color: #303133;
  transition: 0.3s;
  height: 171px;
  padding: 10px 20px 20px 20px;
  background: url(/img/u122.7b61cf7c.png) no-repeat center 110px;
  background-size: 90%;
  background-color: #fff;
  border-radius: 15px;
}

.box-cell .box-icon {
  background-color: #5ad8a6;
  height: 50px;
  width: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.box-cell .box-title {
  display: flex;
  flex-direction: column;
  width: 54%;
}

.box-cell .box-title .online {
  line-height: 30px;
  font-size: 16px;
  font-weight: bold;
}

.box-cell .box-title .yestaday {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.box-cell .box-nums {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.box-cell .box-nums .total {
  line-height: 30px;
  font-size: 30px;
}

.box-cell .box-nums .nums {
  line-height: 26px;
  font-size: 14px;
  color: #999999;
}

.gl-count {
  flex: 1;
  text-align: center;
}

.gl-count p:nth-child(1) {
  font-size: 14px;
  line-height: 23px;
  margin-bottom: 16px;
  color: #666;
}

.gl-count p:nth-child(2) {
  font-size: 38px;
  line-height: 35px;
  color: #1676eb;
  font-weight: bold;
}

.gl-count p:nth-child(2):after {
  box-sizing: border-box;
}
</style>
<script>
import countTo from "vue-count-to";
export default {
  components: { countTo },
  data() {
    this.chartExtend = {
      legend: { show: false }, //隐藏legend
      series: {
        center: ["50%", "50%"],
      },
    };
    return {
      sum_ill: 0,
      sum_manage: 110,
      sum_app: 200,
      today_bill: 30000,
      today_manage: 1254,
      today_app: 0,
      yesterday_bill: 0,
      yesterday_manage: 0,
      yesterday_app: 0,
      billData: {
        columns: ["日期", "金额"],
        rows: [],
      },
      manageData: {
        columns: ["日期", "数量"],
        rows: [],
      },
      appData: {
        columns: ["日期", "数量"],
        rows: [],
      },

      billDate: "",
      manageDate: "",
      appDate: "",
      loading: {
        loading: true,
        billLoading: false,
        manageLoading: false,
        appLoading: false,
      },
      quota: {
        rest: 0,
        limit: 0,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      chartSettings: {
        radius: ["60px", "80px"],
        label: {
          formatter: (params) => {
            if (params.dataIndex === 0) {
              return `{a| 在线设备${params.percent}%}`;
            } else {
              return `{b| 离线设备${params.percent}%}`;
            }
          },
          rich: {
            a: {
              color: "#438de7",
            },
            b: {
              color: "#7b7d86",
            },
          },
        },
      },
      chartData: {
        columns: ["日期", "做题量"],
        rows: [
          { 日期: "8月1日", 做题量: 123 },
          { 日期: "8月2日", 做题量: 1223 },
        ],
      },
      courseData: {
        columns: ["日期", "在线"],
        rows: [
          { 日期: "8月1日", 在线: 1103 },
          { 日期: "8月2日", 在线: 1223 },
          { 日期: "8月3日", 在线: 2323 },
          { 日期: "8月4日", 在线: 4423 },
          { 日期: "8月5日", 在线: 3523 },
          { 日期: "8月6日", 在线: 7623 },
          { 日期: "8月7日", 在线: 7723 },
          { 日期: "8月8日", 在线: 3823 },
          { 日期: "8月9日", 在线: 2923 },
          { 日期: "8月10日", 在线: 2123 },
          { 日期: "8月11日", 在线: 8023 },
          { 日期: "8月12日", 在线: 9023 },
        ],
      },
    };
  },
  created() {
    //this.getIndex();
    this.loading.loading = false;
  },
  methods: {
    getIndex() {
      const that = this;
      that.axios.post("/index/index").then((res) => {
        console.log(res);
        if (res.code == 200) {
          // this.sum_ill = res.data.sum_ill;
          // this.sum_app = res.data.sum_app;
          // this.sum_manage = res.data.sum_manage;
          // this.today_bill = res.data.today_bill;
          // this.today_manage = res.data.today_manage;
          // this.today_app = res.data.today_app;
          // this.yesterday_bill = res.data.yesterday_bill;
          // this.yesterday_manage = res.data.yesterday_manage;
          // this.yesterday_app = res.data.yesterday_app;
          this.loading.loading = false;
        } else {
          this.loading.loading = false;
          that.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
